export const AVATAR_UPDATED_EVENT = 'avatar:updated'
